import React from 'react';

import NoResultsMessage from '@components/NoResultsMessage';
import ForumPostList from '@components/pages/Forum/ForumPostList';
import { ForumPost } from '@utils/backend-api/forumPosts';

import styles from './styles.module.scss';

interface SearchPostsListProps {
  content: ForumPost[];
}

const SearchPostsList = ({ content }: SearchPostsListProps) => {
  return (
    <>
      {content?.length > 0 ? (
        <div className={styles.forumPostList}>
          <ForumPostList forumPosts={content} />
        </div>
      ) : (
        <NoResultsMessage />
      )}
    </>
  );
};

export default SearchPostsList;
